import { Button } from "@/components/ui/button";
import { Chrome, Globe, Compass, Sparkles } from "lucide-react";

const browsers = [
  {
    id: 'chrome',
    name: 'Chrome',
    icon: Chrome,
    url: 'https://chromewebstore.google.com/detail/local-route/jblnfnhiogclplkgpmcajhenoahfjhmp',
    available: true,
  },
  {
    id: 'edge',
    name: 'Edge',
    icon: Globe,
    url: 'https://microsoftedge.microsoft.com/addons/detail/local-route/placeholder',
    available: true,
  },
  {
    id: 'firefox',
    name: 'Firefox',
    icon: Compass,
    url: '#',
    available: false,
  },
  {
    id: 'opera',
    name: 'Opera',
    icon: Compass,
    url: '#',
    available: false,
  },
  {
    id: 'brave',
    name: 'Brave',
    icon: Chrome,
    url: '#',
    available: false,
  },
];

const BrowserDownload = () => {

  return (
    <section id="browsers" className="py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-muted text-sm text-muted-foreground mb-4">
            <Sparkles className="w-3.5 h-3.5" />
            Available for All Browsers
          </div>
          <h2 className="text-3xl font-semibold mb-3">
            Download for Free
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            Start converting text instantly. Free forever, no account needed.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 max-w-3xl mx-auto">
          {browsers.map((browser, index) => (
            <div 
              key={browser.id} 
              className="flex flex-col items-center text-center gap-3 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className={`
                bg-card border rounded-lg p-5 w-full aspect-square flex items-center justify-center 
                ${browser.available ? 'border-foreground/20' : 'border-border'}
                hover:border-foreground/30 transition-all
              `}>
                <browser.icon 
                  className={`w-8 h-8 ${browser.available ? 'text-foreground' : 'text-muted-foreground'}`} 
                />
              </div>
              <span className="font-medium text-sm">{browser.name}</span>
              <Button 
                className="w-full text-xs"
                variant={browser.available ? "default" : "outline"}
                size="sm"
                asChild={browser.available}
                disabled={!browser.available}
              >
                {browser.available ? (
                  <a href={browser.url} target="_blank" rel="noopener noreferrer">
                    Download
                  </a>
                ) : (
                  <span className="text-muted-foreground">Coming Soon</span>
                )}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrowserDownload;
